import axios from "axios";

export const state = {
    expenseitems: [],
};

export const getters = {
    expenseitems: state => state.expenseitems,
};

export const mutations = {
    setExpenseitems(state, newValue) {
        state.expenseitems = newValue
    },
};

export const actions = {
    async fetchExpenseitems({ commit }) {
        await axios.get('/expenseitem').then(res => {
            commit('setExpenseitems', res.data.categories)
        })
    },
};
